<template>
    <div class="container-fluid pt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Delivery</h5>
                    <div class="d-flex align-items-center">
                        <div class="col-md-"><select v-model="params.divisi_id" class="form-select btn-sm">
                                <option value="">All Divisi</option>
                                <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">{{
                                    (option as any).name }}</option>
                            </select></div>
                        <button type="button" class="btn btn-sm btn-success ms-1 me-1" @click="printRekapWa"
                            :disabled="loading">
                            <i class="fab fa-whatsapp"></i> Whatsapp
                        </button>
                        <button class="btn btn-sm btn-primary ms-1 me-1" @click="isform = !isform; data = null"
                            :disabled="loading"><i class="fa fa-solid fa-plus"></i>
                            Create</button>
                        <button type="button" class="btn btn-sm btn-info ms-1 me-1" @click="processDownloadXls"
                            :disabled="loading"><i class="fa-regular fa-file-excel"></i>
                            XLS</button>
                        <button type="button" class="btn btn-sm btn-danger ms-1 me-1" @click="processDownloadPDF"
                            :disabled="loading"><i class="fa-solid fa-file-pdf"></i> PDF</button>
                    </div>
                </div>
                <div class="col-md-12 p-2">
                    <div class="row general-widget">
                        <Card1 colClass="col-sm-4 col-xl-4 box-col-4" cardClass="card widget-1 mb-0"
                            v-for="(item, index) in widgets" :key="index">
                            <div class="widget-content">
                                <div class="widget-round" :class="[item.class, item.font]">
                                    <div class="bg-round">
                                        <i :class="['fa-solid', item.svg1]" class="svg-fill fa-2x"></i>
                                    </div>
                                </div>
                                <div>
                                    <h4>{{ item.number }}</h4>
                                    <span class="f-light">{{ item.title }}</span>
                                </div>
                            </div>
                        </Card1>
                        <div class="col-12 col-md-4">
                            <div class="col-md-12 mb-3">
                                <select v-model="params.shipping_id" class="form-select">
                                    <option value="">Select Shipping</option>
                                    <option v-for="option in shippingOptions" :key="option.ID" :value="option.ID">
                                        {{ option?.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3">
                                <select v-model="params.courier_id" class="form-select">
                                    <option value="">Select Courier</option>
                                    <option v-for="option in courierOptions" :key="option.ID" :value="option.ID">
                                        {{ option?.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <DataTable :headers="headers" :items="warehouseDelivery" :loading="loading" :total="total"
                    :params="params" @update:params="updateParams">
                    <template #item.delivery_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        formatDateTime(item.delivery_date) }}</template>
                    <template #item.divisi="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.ID }}</template>
                    <template #item.customer="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.customer }}</template>
                    <template #item.total_so="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        totalSo(item.delivery_details) }}</template>
                    <template #item.total_produk="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        totalProduk(item.delivery_details) }}</template>
                    <template #item.actions="{ item }">
                        <button v-if="item.maps_link" class="btn btn-sm btn-secondary ms-1 me-1"
                            @click="openMapsLink(item.maps_link)">
                            <i class="fa-solid fa-map-location-dot"></i>
                        </button>
                        <button class="btn btn-sm btn-info ms-1 me-1" @click="exportJNT(item)">
                            <i class="fa-solid fa-file-export"></i>
                        </button>
                        <button class="btn btn-sm btn-warning ms-1 me-1" @click="isView = true; data = item">
                            <i class="fa fa-solid fa-eye"></i>
                        </button>
                        <button class="btn btn-sm btn-danger ms-1 me-1" @click="processDownloadPDF(item)">
                            <i class="fa fa-solid fa-file-pdf"></i>
                        </button>
                        <button class="btn btn-sm btn-warning ms-1 me-1" @click="isform = !isform; data = item">
                            <i class="fa fa-solid fa-pencil"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
    <Form title="Create Delivery" v-if="isform" :data="data" @on-closed="isform = false; fetchDelivery()" />
    <View title="View Delivery" v-if="isView" :data="data" @on-closed="isView = false" />
</template>

<script lang="ts" setup>
import { ref, watch, reactive, onMounted, defineAsyncComponent } from 'vue'
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))
const Form = defineAsyncComponent(() => import("./Form.vue"))
const View = defineAsyncComponent(() => import("./View.vue"))
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import * as master from '@/api/services/MasterRequest'
import * as warehouse from '@/api/services/WarehouseRequest'
import * as sales from '@/api/services/SalesRequest'
import * as ExcelJS from 'exceljs'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const isform = ref(false)
const isView = ref(false)
const data = ref<any>(null)
const divisiOptions = ref<{ ID: any }[]>([])
const shippingOptions = ref<{ ID: any, name: string }[]>([])
const courierOptions = ref<{ ID: any, name: string }[]>([])
const widgets = ref([
    {
        class: "danger",
        svg1: "fa-cart-shopping", // Updated to Font Awesome cart shopping icon
        svg2: "halfcircle",
        number: "0",
        title: "ORDER WAITING",
        font: "font-danger",
        icon: "icon-arrow-up",
        total: "+50%"
    },
    {
        class: "secondary",
        svg1: "fa-box-archive", // Updated to Font Awesome box archive icon
        svg2: "halfcircle", 
        number: "0",
        title: "ORDER DELIVERY",
        font: "font-secondary",
        icon: "icon-arrow-down",
        total: "-20%"
    },
])

const headers = [
    { text: 'Divisi', value: 'divisi_name' },
    { text: 'Delivery No', value: 'code' },
    { text: 'Delivery Date', value: 'delivery_date' },
    { text: 'Shipping', value: 'shipping_name' },
    { text: 'Courier', value: 'courier_name' },
    { text: 'Note', value: 'notes' },
    { text: 'Total SO', value: 'total_so' },
    { text: 'Total Produk', value: 'total_produk' },
    { text: 'Createsd By', value: 'created_by' },
    { text: '#Act', value: 'actions' }
]

// {{ Apply types to refs and reactive objects }}
const warehouseDelivery = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    divisi_id: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.ID,
    shipping_id: '',
    courier_id: '',

})

const phoneUser = session.getUser().phone
const exportJNT = async (item: any) => {
    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Delivery Details');

        // Set up headers
        worksheet.columns = [
            { header: 'Berat', key: 'weight', width: 10 },
            { header: 'Nama Pengirim', key: 'sender_name', width: 20 },
            { header: 'Telepon Pengirim', key: 'sender_phone', width: 15 },
            { header: 'Kota Pengirim', key: 'sender_city', width: 15 },
            { header: 'Alamat Pengirim', key: 'sender_address', width: 30 },
            { header: 'Informasi Alamat Pengirim', key: 'sender_address_info', width: 30 },
            { header: 'Apakah Dropship?', key: 'is_dropship', width: 15 },
            { header: 'Nama Dropshiper', key: 'dropshipper_name', width: 20 },
            { header: 'Telfon Dropshiper', key: 'dropshipper_phone', width: 15 },
            { header: 'Nama Penerima', key: 'receiver_name', width: 20 },
            { header: 'Telepon Penerima', key: 'receiver_phone', width: 15 },
            { header: 'Provinsi Penerima', key: 'province', width: 15 },
            { header: 'Kota Penerima', key: 'city', width: 15 },
            { header: 'Kecamatan', key: 'district', width: 15 },
            { header: 'Alamat Penerima', key: 'receiver_address', width: 30 },
            { header: 'Informasi Alamat Penerima', key: 'receiver_address_info', width: 30 },
            { header: 'Cara Pembayaran', key: 'payment_method', width: 15 },
            { header: 'Nama Barang', key: 'product_name', width: 20 },
            { header: 'Nilai Barang', key: 'product_value', width: 15 },
            { header: 'Jenis asuransi', key: 'insurance_type', width: 15 },
            { header: 'Apakah Input Asuransi?', key: 'has_insurance', width: 20 },
            { header: 'Jumlah', key: 'quantity', width: 10 },
            { header: 'Jenis Barang', key: 'product_type', width: 15 },
            { header: 'Keterangan', key: 'notes', width: 20 },
            { header: 'Nomor pesanan e-commerce', key: 'ecommerce_order_number', width: 25 },
            { header: 'COD', key: 'is_cod', width: 10 },
            { header: 'Jenis Layanan', key: 'service_type', width: 15 },
            { header: 'Biaya Pengiriman', key: 'shipping_cost', width: 15 },
            { header: 'Biaya Lainnya', key: 'other_costs', width: 15 }
        ];

        // Add data rows
        item.delivery_details.forEach((detail: any) => {
            const orderData = JSON.parse(detail.order_data || '{}')
            console.log(orderData)

            if (detail.waybill_no == '') {
                worksheet.addRow({
                    weight: 1,
                    sender_name: orderData.divisi_team_name || '',
                    sender_phone: phoneUser || '08111758115',
                    sender_city: 'CIPUTAT',
                    sender_address: 'Jl. H. Basir No.128, RT.4/RW.2, Pd. Kacang Bar., Kec. Pd. Aren, Kota Tangerang Selatan, Banten 15226',
                    sender_address_info: item.sender?.address_info || '',
                    is_dropship: 0,
                    dropshipper_name: '',
                    dropshipper_phone: '',
                    receiver_name: orderData.customer_name || '',
                    receiver_phone: orderData.customer_phone || '',
                    district: orderData.customer_area || '',
                    receiver_address: orderData.customer_address || '',
                    receiver_address_info: '',
                    payment_method: 'BULANAN',
                    product_name: orderData.order_details[0].name || '',
                    product_value: orderData.sub_total || 0,
                    insurance_type: orderData.insurance_type || '',
                    has_insurance: 1,
                    quantity: orderData.qty_total || 0,
                    product_type: 'BARANG',
                    notes: orderData.notes || '',
                    ecommerce_order_number: orderData.code || '',
                    is_cod: orderData.payment == 'COD' ? orderData.grand_total : '',
                    service_type: 'EZ',
                    shipping_cost: orderData.shipping_cost || 0,
                    other_costs: ''
                });
            }
        });

        // Style the header row
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' }
        };

        // Generate file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // Trigger download
        const link = document.createElement('a');
        link.href = url;
        link.download = `JNT_delivery_${item.code}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        toast.error('Failed to export JNT')
        console.log(error)
    }
}

const fetchSalesDelivery = async () => {
    loading.value = true
    try {
        await sales.postRequest("/dashboard/sales-delivery", params).then((response) => {
            if (response.data) {
                response.data.forEach((item: any) => {
                    widgets.value[0].number = item.order_waiting
                    widgets.value[1].number = item.order_delivery
                })
            }
        });

    } catch (error) {
        toast.error('Failed to fetch warehouse delivery')
    }
    loading.value = false
}

const fetchDelivery = async () => {
    data.value = {}
    loading.value = true
    try {
        // Simulate API delay
        await warehouse.postRequest("/delivery/list", params).then((response) => {
            warehouseDelivery.value = response.data;
            total.value = response.total
        });

        loading.value = false
    } catch (error) {
        toast.error('Failed to fetch warehouse delivery')
        loading.value = false
    }
}

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchDelivery()
    fetchSalesDelivery()
}

const fetchShipping = async () => {
    loading.value = true
    try {
        // Simulate API delay
        await master.postRequest("/shipping/list", params).then((response) => {
            shippingOptions.value = response.data;
        });

    } catch (error) {
        toast.error('Failed to fetch salesOrders')
    }
    loading.value = false
}

watch(() => params.shipping_id, (newVal) => {
    params.courier_id = ''
    courierOptions.value = shippingOptions.value.find(s => s.ID === newVal)?.couriers
});
onMounted(() => {
    divisiOptions.value = session.divisionOptions()
    fetchShipping();

})

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}

function totalSo(items: any[]) {
    return separator(items.length);
}

function totalProduk(items: any[]) {
    return separator(items.reduce((total, item) => total + item.qty_total, 0));
}

function separator(value: number) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function openMapsLink(link: string) {
    if (!link) return
    window.open(link, '_blank', 'noopener,noreferrer')
}


const processDownloadXls = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const prms = { ...params }
        prms.size = 10000
        try {
            const response = await warehouse.getDownload("/delivery/xlsx", prms);
            // Create blob from response data
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'delivery.xlsx');
            // Trigger download
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            toast.error('Failed to download file. Please try again.');
        }

    } catch (error) {
        toast.error('Failed to fetch delivery')
    }
    loading.value = false
}
const processDownloadPDF = async (item: any = null) => {
    loading.value = true
    try {
        // Simulate API delay
        const prms = { ...params }
        if (item)
            prms.ID = item.ID
        prms.size = 10000
        try {
            const response = await warehouse.getDownload("/delivery/pdf", prms);
            // Create blob from response data
            const blob = new Blob([response], { type: 'application/pdf' });
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'delivery.pdf');
            // Trigger download
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            toast.error('Failed to download file. Please try again.');
        }

    } catch (error) {
        toast.error('Failed to fetch delivery')
    }
    loading.value = false
}

const deleteData = async (id: number) => {
    if (!confirm('Are you sure you want to delete this Delivery?')) return

    loading.value = true
    try {
        await warehouse.postRequest("/delivery/delete", { ID: id }).then((resp) => {
            if (resp.status === 200) {
                toast.success('Delivery deleted successfully');
                fetchDelivery();
            } else {
                toast.error('Failed to delete Delivery');
            }
        })

    } catch (error: any) {
        toast.error(error.message || 'Failed to delete Delivery');
    } finally {
        loading.value = false
    }
}

function printRekapWa() {
    if (!warehouseDelivery.value || warehouseDelivery.value.length === 0) {
        toast.warning('Tidak ada data pengiriman untuk ditampilkan');
        return;
    }

    // Kelompokkan data berdasarkan tanggal pengiriman
    const groupedByDate = warehouseDelivery.value.reduce((acc, delivery) => {
        const deliveryDate = formatDateTime(delivery.delivery_date, '-', ' ').split(' ')[0];
        if (!acc[deliveryDate]) {
            acc[deliveryDate] = [];
        }
        acc[deliveryDate].push(delivery);
        return acc;
    }, {});

    let waMessage = '📦 *REKAP PENGIRIMAN GUDANG* 📦\n';

    // Track total quantities for grand total
    const grandTotalByProduct = {};
    const grandTotalByDivisi = {};

    Object.keys(groupedByDate).forEach(date => {
        waMessage += '━━━━━━━━━━━━━━━━━━━━\n';
        waMessage += `📅 *Tanggal: ${date}*\n`;
        const deliveries = groupedByDate[date];
        // Kelompokkan berdasarkan produk dari delivery_details
        const productGroups = {};
        deliveries.forEach(delivery => {
            delivery.delivery_details.forEach(detail => {
                try {
                    const orderData = JSON.parse(detail.order_data || '{}');
                    if (orderData.order_details && orderData.order_details.length > 0) {
                        orderData.order_details.forEach(product => {
                            const productName = product.name || 'Produk Tidak Diketahui';
                            if (!productGroups[productName]) {
                                productGroups[productName] = {};
                            }

                            const divisiName = delivery.divisi_name || 'Divisi Tidak Diketahui';
                            if (!productGroups[productName][divisiName]) {
                                productGroups[productName][divisiName] = {
                                    quantity: 0,
                                    orders: [],
                                    courier: delivery.courier_name,
                                    shipping: delivery.shipping_name
                                };
                            }

                            const quantity = product.quantity || 0;
                            productGroups[productName][divisiName].quantity += quantity;

                            // Update grand totals
                            grandTotalByProduct[productName] = (grandTotalByProduct[productName] || 0) + quantity;
                            grandTotalByDivisi[divisiName] = (grandTotalByDivisi[divisiName] || 0) + quantity;

                            productGroups[productName][divisiName].orders.push({
                                orderNo: orderData.code,
                                customerName: orderData.customer_name,
                                customerAddress: orderData.customer_address,
                                waybillNo: detail.waybill_no,
                                packingName: detail.packing_name,
                                salesName: detail.sales_name
                            });
                        });
                    }
                } catch (error) {
                    console.error('Error parsing order_data:', error);
                }
            });
        });

        // Format output berdasarkan produk dan divisi
        Object.keys(productGroups).forEach(productName => {
            waMessage += `🏷️ *PRODUK: ${productName}*\n`;
            waMessage += '━━━━━━━━━━━━━━━━━━━━\n';
            Object.keys(productGroups[productName]).forEach(divisiName => {
                const divisiData = productGroups[productName][divisiName];
                waMessage += `📋 *Divisi: ${divisiName}*\n`;
                waMessage += `📊 Total Quantity: *${divisiData.quantity} pcs*\n`;
            });
        });
        waMessage += '\n';
    });

    waMessage += '━━━━━━━━━━━━━━━━━━━━\n';
    waMessage += '✅ *Rekap Selesai*\n';
    waMessage += `📊 Total Pengiriman: *${warehouseDelivery.value.length}*\n`;
    waMessage += '━━━━━━━━━━━━━━━━━━━━\n';

    // Add grand total by product
    waMessage += '📊 *Total Per Produk:*\n';
    Object.entries(grandTotalByProduct).forEach(([product, total]) => {
        waMessage += `${product}: *${total} pcs*\n`;
    });
    waMessage += '\n';

    // Add grand total by divisi
    waMessage += '📊 *Total Per Divisi:*\n';
    Object.entries(grandTotalByDivisi).forEach(([divisi, total]) => {
        waMessage += `${divisi}: *${total} pcs*\n`;
    });
    waMessage += '\n';

    waMessage += `📅 Generated: ${formatDateTime(new Date().toISOString(), '-', ' ')}`;

    // Copy ke clipboard
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(waMessage).then(() => {
            toast.success('Format WhatsApp berhasil disalin ke clipboard! 📋');
        }).catch(() => {
            fallbackCopyTextToClipboard(waMessage);
        });
    } else {
        fallbackCopyTextToClipboard(waMessage);
    }
}

function fallbackCopyTextToClipboard(text: string) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
        document.execCommand('copy')
        toast.success('WhatsApp format copied to clipboard!')
    } catch (err) {
        toast.error('Failed to copy to clipboard')
        console.error('Fallback: Oops, unable to copy', err)
    }
    document.body.removeChild(textArea)
}

</script>
